import { isEmpty } from 'lodash';
import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const WHATSAPP_PLAN_LOADING = "WHATSAPP_PLAN_LOADING";
export const STOP_WHATSAPP_PLAN_LOADING = "STOP_WHATSAPP_PLAN_LOADING";
export const WHATSAPP_PLAN_SUCCESS = "WHATSAPP_PLAN_SUCCESS";
export const WHATSAPP_PLAN_FAILED = "WHATSAPP_PLAN_FAILED";

export const WHATSAPP_SUPPORTED_COUNTRIES_LOADING = "WHATSAPP_SUPPORTED_COUNTRIES_LOADING"
export const WHATSAPP_SUPPORTED_COUNTRIES_SUCCESS = "WHATSAPP_SUPPORTED_COUNTRIES_SUCCESS"
export const WHATSAPP_SUPPORTED_COUNTRIES_FAILED = "WHATSAPP_SUPPORTED_COUNTRIES_FAILED"

export const CUSTOM_PLAN_REQUEST_SENDING = "CUSTOM_PLAN_REQUEST_SENDING"
export const CUSTOM_PLAN_REQUEST_SUCCESS = "CUSTOM_PLAN_REQUEST_SUCCESS"
export const CUSTOM_PLAN_REQUEST_ERROR = "CUSTOM_PLAN_REQUEST_ERROR"

export const FETCH_WAPRICING_LOADING = "FETCH_WAPRICING_LOADING";
export const FETCH_WAPRICING_SUCCESS = "FETCH_WAPRICING_SUCCESS";
export const FETCH_WAPRICING_FAILED = "FETCH_WAPRICING_FAILED";


export const getWhatsappPlans = (data: any) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: WHATSAPP_PLAN_LOADING });
        networkCall("get", `/whatsapp/plans?service_name=${data.serviceName}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data && res.data.length) {
                    dispatch({ type: WHATSAPP_PLAN_SUCCESS, payload: { res: res } });
                } else {
                    dispatch({ type: WHATSAPP_PLAN_FAILED, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: WHATSAPP_PLAN_FAILED, payload: { error } });
                }
            });
    }
}
export const fetchPricingDetails = (type:string) => {
    return (dispatch:Dispatch<any>) => {

        dispatch({type: FETCH_WAPRICING_LOADING});

        let data = {
            services: [type],
            send_full_list: true
        }
        networkCall("post", `/price`, apiBaseUrl.baseUrl, true, true, data)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({type: FETCH_WAPRICING_SUCCESS, payload: {res: res}});
            }else{
                dispatch({type: FETCH_WAPRICING_FAILED, payload: {error: res}});
            }
        }).catch((error:any)=>{
            if(error?.response?.data){
                dispatch({ type: FETCH_WAPRICING_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const getWhatsappSupportedCountries = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: WHATSAPP_SUPPORTED_COUNTRIES_LOADING });
        networkCall("get", `/whatsapp/supported-countries`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data && res.data.length) {
                    dispatch({ type: WHATSAPP_SUPPORTED_COUNTRIES_SUCCESS, payload: { res: res } });
                } else {
                    dispatch({ type: WHATSAPP_SUPPORTED_COUNTRIES_FAILED, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: WHATSAPP_SUPPORTED_COUNTRIES_FAILED, payload: { error: error } });
                }
            });
    }
}

export const sendCustomPlanEnquiry = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CUSTOM_PLAN_REQUEST_SENDING });
        networkCall("post", `/whatsapp/request-custom-plan`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.code && res.code === 200) {
                    dispatch({ type: CUSTOM_PLAN_REQUEST_SUCCESS, payload: { res: res } });
                    //on success, call whatsappplans api
                    dispatch(getWhatsappPlans({ serviceName: "whatsapp" }))
                } else {
                    dispatch({ type: CUSTOM_PLAN_REQUEST_ERROR, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: CUSTOM_PLAN_REQUEST_ERROR, payload: { error: error } });
                }
            });
    }
}